import i18n from "@/i18n";
import {
  SERVICE_WORKER_REGISTRATION_OPTIONS,
  versionedServiceWorkerUrl,
} from "@/lib/service-worker";
import { useEffect, useRef } from "react";
import { toast } from "sonner";

export function useServiceWorker() {
  const toastShown = useRef(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const showUpdateToast = () => {
      if (toastShown.current) return;
      toastShown.current = true;

      toast(i18n.t("pwa.update.title", { ns: "common" }), {
        duration: Infinity,
        action: {
          label: i18n.t("pwa.update.action", { ns: "common" }),
          onClick: () => window.location.reload(),
        },
      });
    };

    const serviceWorkerUrl = versionedServiceWorkerUrl(
      __SERVICE_WORKER_REVISION__,
    );

    navigator.serviceWorker
      .register(serviceWorkerUrl, SERVICE_WORKER_REGISTRATION_OPTIONS)
      .then((registration) => {
        // Check if update is already waiting
        if (registration.waiting) {
          showUpdateToast();
          return;
        }

        // Listen for new updates
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              showUpdateToast();
            }
          });
        });
      })
      .catch((err) => console.log("Service Worker registration failed:", err));
  }, []);
}
